/* eslint-disable react/jsx-pascal-case */
import { useState } from "react";
import styled from "styled-components";
import { Content_Text } from "../Component/theme";
import { useNavigate } from "react-router-dom";
import Logo from "../image/Logo_Linkcampus3.png";

import Privacy_Policy_Modal from "../Component/Privacy_Policy_Modal";
import Terms_Modal from "../Component/Terms_Modal";

const Image = styled.img`
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  -khtml-user-drag: none;
  -moz-user-drag: none;
  -o-user-drag: none;
`;

const Main_Content = styled.div`
  flex: 1;
  display: grid;
  position: relative;
  justify-content: ${(props) => (props.$left ? "flex-start" : "center")};
  align-self: ${(props) => (props.$center ? "center" : "")};
  text-align: ${(props) => (props.$left ? "flex-start" : "center")};

  @media (max-width: 1500px) {
    padding: 0px 60px 20px 60px;
    /* text-align: center; */
  }
  @media (max-width: 800px) {
    padding: 0px 15px 20px 15px;
    /* text-align: center; */
  }
`;

const Footer_Text = styled(Content_Text)`
  margin-top: 5px;
  text-align: left;
`;

const Footer_div = styled.div`
  display: flex;
  justify-self: center;
  flex-direction: row;
  justify-content: space-between;
  width: 20%;
  justify-self: flex-start;
  padding-top: 40px;
  @media (max-width: 800px) {
    width: 40%;
    padding-top: 20px;
  }
`;
const Footer_Bar = styled.div`
  border-width: 0px 0px 1px 0px;
  border-color: #707070;
  border-style: solid;
  width: 1280px;
  margin: 40px 0px;
  @media (max-width: 800px) {
    width: 100%;
    margin: 20px 0px;
  }
`;
const Footer_Text2 = styled(Content_Text)`
  transition: color 0.2s ease;

  &:hover {
    color: #33cccc;
  }
`;
const Logo_img = styled(Image)`
  position: absolute;
  right: 0px;
  top: 140px;
  width: 170px;
  @media (max-width: 800px) {
    width: 85px;
    top: 180px;
    right: 15px;
  }
`;
const NotSee = styled.div`
  opacity: 0;
`;

function Footer_FMS() {
  const navigation = useNavigate();

  const [call, set_Call] = useState(false);
  const [privacy_policy, set_Privacy_Policy] = useState(false);
  const [terms, set_Terms] = useState(false);
  const open_privacy_policy = () => set_Privacy_Policy(true);
  const close_privacy_policy = () => set_Privacy_Policy(false);
  const open_terms = () => set_Terms(true);
  const close_terms = () => set_Terms(false);

  return (
    <Main_Content $left>
      <Logo_img src={Logo} alt={Logo} />
      <Footer_div>
        <Footer_Text2 $white onClick={open_terms} style={{ cursor: "pointer" }}>
          이용약관
        </Footer_Text2>
        <Footer_Text2
          $white
          onClick={open_privacy_policy}
          style={{ cursor: "pointer" }}
        >
          개인정보처리방침
        </Footer_Text2>
      </Footer_div>
      <Footer_Bar></Footer_Bar>

      <Footer_Text $lightGray $small>
        상호 : 링크캠퍼스&nbsp;&nbsp;|&nbsp;&nbsp;대표 : 이헌영
      </Footer_Text>
      <Footer_Text $lightGray $small>
        사업자 등록번호 : 117-18-78102&nbsp;&nbsp;|&nbsp;&nbsp; 주소 :
        광주광역시 동구 필문대로 287번길 3 조대장미의 거리 고객센터, 링크캠퍼스
      </Footer_Text>
      <Footer_Text $lightGray $small>
        문의전화 : 0507-1336-7115&nbsp;&nbsp;|&nbsp;&nbsp; E-mail :
        linkcampus01@gmail.com
      </Footer_Text>
      <Footer_Text $lightGray $small>
        Copyright © Linkcampus All Rights Reserved&nbsp;&nbsp;|&nbsp;&nbsp;
        Designed by Freepik
      </Footer_Text>

      <Privacy_Policy_Modal
        show={privacy_policy}
        onClose={close_privacy_policy}
      />
      <Terms_Modal show={terms} onClose={close_terms} />
      <NotSee>
        FMS,FMS시스템,시설물통합정보시스템(FMS),FMS시설물정보관리시스템,BTL,시설물통합정보관리시스템,CMMS,설비관리시스템,설비관리,관리대장,문서중앙화,시설관리,자재관리,시설관리,건물관리
      </NotSee>
    </Main_Content>
  );
}

export default Footer_FMS;
